export default __webpack_public_path__ + "static/media/paused-image.abf45e73.png";